import * as React from "react";
const SvgGrayReset = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M1.583 18.557c1.57 5.959 6.987 10.348 13.432 10.348a13.86 13.86 0 0 0 13.89-13.89c0-9.265-7.723-13.89-7.723-13.89m0 0h4.598m-4.598 0v4.43m-6.167-4.43c-7.667 0-13.89 6.223-13.89 13.89"
    />
  </svg>
);
export default SvgGrayReset;
